module.exports = __webpack_public_path__ + "img/solution-data-advantage2.ada06499.svg";